import ForgetPassword from "@/pages/ForgetPassword";
import Login from "@/pages/Login";
import Notifications from "@/pages/Notifications";
import { lazy } from "react";
import { BsBarChart } from "react-icons/bs";
import { FaQuestion, FaRegMoneyBill1 } from "react-icons/fa6";
import { LuBoxes } from "react-icons/lu";
import { MdOutlineDiscount, MdOutlineHeadset } from "react-icons/md";
import { RiListSettingsFill } from "react-icons/ri";
import { RxDashboard } from "react-icons/rx";
import { TbUser } from "react-icons/tb";

const Dashboard = lazy(() => import("../pages/Dashboard"));
const UserManagement = lazy(() => import("../pages/UserManagement"));
const SubscriptionManagement = lazy(() =>
  import("../pages/SubscriptionManagement")
);
const ReportsAndAnalytics = lazy(() => import("../pages/ReportsAndAnalytics"));
const HelpAndSupport = lazy(() => import("../pages/HelpAndSupport"));
const Settings = lazy(() => import("../pages/Settings"));
const Cms = lazy(() => import("../pages/Cms"));
const PromotionCode = lazy(() => import("../pages/PromotionCode"));
const Faqs = lazy(() => import("../pages/Faqs"));
const UserDetail = lazy(() => import("../pages/UserManagement/UserDetail"));
const ProjectsDetails = lazy(() => import("../pages/ProjectDetails"));
const ProjectsManagement = lazy(() => import("../pages/Projects"));

export const routes = [
  {
    path: "/login",
    exact: true,
    protected: false,
    showInSidebar: false,
    title: "Login",
    icon: <RxDashboard />,
    element: <Login />,
  },
  {
    path: "/forget-password",
    exact: true,
    protected: false,
    showInSidebar: false,
    title: "Forget Password",
    icon: <RxDashboard />,
    element: <ForgetPassword />,
  },
  {
    path: "/",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Dashboard",
    icon: <RxDashboard />,
    element: <Dashboard />,
  },
  {
    path: "/user-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "User Management",
    icon: <TbUser />,
    element: <UserManagement />,
  },
  {
    path: "/user-management/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "User Detail",
    element: <UserDetail />,
  },
  {
    path: "/projects",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Projects",
    icon: <LuBoxes />,
    element: <ProjectsManagement />,
  },
  {
    path: "/project/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Projects",
    icon: <LuBoxes />,
    element: <ProjectsDetails />,
  },
  {
    path: "/subscription-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Subscription Management",
    icon: <FaRegMoneyBill1 />,
    element: <SubscriptionManagement />,
  },
  {
    path: "/reports-and-analytics",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Reports & Analytics",
    icon: <BsBarChart />,
    element: <ReportsAndAnalytics />,
  },
  {
    path: "/help-and-support",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Help & Support",
    icon: <MdOutlineHeadset />,
    element: <HelpAndSupport />,
  },
  {
    path: "/promotion-code",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Promotion Code",
    icon: <MdOutlineDiscount />,
    element: <PromotionCode />,
  },
  {
    path: "/faqs",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "FAQs",
    icon: <FaQuestion />,
    element: <Faqs />,
  },
  {
    path: "/settings",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <Settings />,
  },
  {
    path: "/cms",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "CMS",
    icon: <RiListSettingsFill />,
    element: <Cms />,
  },
  {
    path: "/notifications",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <Notifications />,
  },
];
